import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Container,
  Image,
  Icon,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility,
  Header,
  Grid
} from "semantic-ui-react";

import MemberUpdateForm from "../components/MemberUpdateForm";
import AddProjectForm from "../components/AddProjectForm";
import ProjectUpdateForm from "../components/ProjectUpdateForm";

import * as LINKS from "../assets/Links";
import LOGO from "../assets/images/logo.png";
import Footer from "../components/Footer";

const getWidth = () => {
  const isSSR = typeof window === "undefined";
  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth;
};

class DesktopNav extends Component {
  state = { email: "" };

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  componentWillMount() {
    if (localStorage.getItem("email"))
      this.setState({ email: localStorage.getItem("email") });
    else this.setState({ email: undefined });
  }

  render() {
    const { children } = this.props;
    const { fixed } = this.state;
    let rightMenuItem;
    if (this.state.email === "" || this.state.email === undefined) {
      rightMenuItem = (
        <Menu.Item
          // as="a"
          // href="#/"
          active={this.props.activeItem === "home"}
          style={{ backgroundColor: "#111111" }}
          position="right"
        >
          <Image src={LOGO} size="mini" />
        </Menu.Item>
      );
    } else {
      rightMenuItem = (
        <Menu.Item position="right" style={{ backgroundColor: "#111111" }}>
          <Header inverted>{this.state.email}</Header>
        </Menu.Item>
      );
    }

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <Segment
            inverted
            textAlign="center"
            style={{
              padding: "1em 0em",
              backgroundColor: "#111111"
            }}
            vertical
          >
            <Menu
              fixed={fixed ? "top" : null}
              inverted={!fixed}
              pointing={!fixed}
              secondary={!fixed}
              size="large"
            >
              <Menu.Item
                as="a"
                href="#/"
                active={this.props.activeItem === "home"}
                style={{ backgroundColor: "#111111" }}
              >
                <Image src={LOGO} size="mini" />
              </Menu.Item>

              <Menu.Item
                as="a"
                href={LINKS.MEDIUM_BLOGS_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                Blogs
              </Menu.Item>
              {rightMenuItem}
            </Menu>
          </Segment>
        </Visibility>
        {children}
      </Responsive>
    );
  }
}

DesktopNav.propTypes = {
  children: PropTypes.node
};

class MobileNav extends Component {
  state = { email: "" };

  componentWillMount() {
    if (localStorage.getItem("email"))
      this.setState({ email: localStorage.getItem("email") });
    else this.setState({ email: undefined });
  }

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    let rightMenuItem;
    if (this.state.email === "" || this.state.email === undefined) {
      rightMenuItem = (
        <Menu.Item
          as="a"
          href="#/"
          active={this.props.activeItem === "home"}
          style={{ backgroundColor: "#111111" }}
          position="right"
        >
          <Image src={LOGO} size="mini" />
        </Menu.Item>
      );
    } else {
      rightMenuItem = (
        <Menu.Item position="right" style={{ backgroundColor: "#111111" }}>
          <Header inverted>{this.state.email}</Header>
        </Menu.Item>
      );
    }

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation="push"
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <Menu.Item
            as="a"
            href="#/"
            active={this.props.activeItem === "home"}
            style={{ backgroundColor: "#111111" }}
          >
            <Image src={LOGO} size="mini" />
          </Menu.Item>

          <Menu.Item
            as="a"
            href={LINKS.MEDIUM_BLOGS_LINK}
            target="_blank"
            rel="noopener noreferrer"
          >
            Blogs
          </Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign="center"
            size="massive"
            style={{
              padding: "1em 0em",
              backgroundColor: "#111111"
            }}
            vertical
          >
            <Container fluid>
              <Menu inverted pointing secondary size="large">
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name="sidebar" />
                </Menu.Item>
                {rightMenuItem}
              </Menu>
            </Container>
            <div />
          </Segment>
          {children}
        </Sidebar.Pusher>
      </Responsive>
    );
  }
}

MobileNav.propTypes = {
  children: PropTypes.node
};

const ResponsiveContainer = ({ children }) => (
  <div>
    <DesktopNav>{children}</DesktopNav>
    <MobileNav>{children}</MobileNav>
  </div>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node
};

const GetOut = () => (
  <Segment
    inverted
    vertical
    style={{ padding: "14em 0em", backgroundColor: "#111111" }}
  >
    <Header as="h2" textAlign="center">
      You should not be here! Go login!
    </Header>
  </Segment>
);

const validateUser = () => {
  if (!localStorage.getItem("dat")) {
    console.log("You should not be here!");
    return GetOut();
  } else {
    return (
      <Container>
        <Grid columns="equal" stackable>
          <Grid.Column>
              <MemberUpdateForm />
              <AddProjectForm />
          </Grid.Column>
          <Grid.Column>
            <ProjectUpdateForm />
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
};

const Dashboard = () => (
  <ResponsiveContainer>
    {validateUser()}
    <Footer />
  </ResponsiveContainer>
);

export default Dashboard;
